module.exports = __webpack_public_path__ + "img/0da3950bebc18b9506874c341886af49.svg";